export const formatDictData = (dictData, filterDataFun, disabledDataFun) => {
  const obj = {}
  for (const key in dictData) {
    obj[key] = disabledDataFun(filterDataFun(dictData[key]))
  }
  return obj
}